<router-view :result="result" :loadingResult="loading" :updateResult="update" :changeResult="change"></router-view>